import { type Theme } from '../theme';

export type FontWeight = 'regular' | 'medium' | 'semi-bold';

type Props = {
  theme: Theme;
  fontWeight?: FontWeight;
};

export const getFontWeight = ({ theme, fontWeight }: Props): number => {
  switch (fontWeight) {
    case 'regular': {
      return theme.typography.fontWeightRegular;
    }
    case 'medium': {
      return theme.typography.fontWeightMedium;
    }
    case 'semi-bold': {
      return theme.typography.fontWeightSemiBold;
    }
    default: {
      return theme.typography.fontWeightRegular;
    }
  }
};
